module.exports = __webpack_public_path__ + "img/boxeymuffet.e4769576.jpg";